import { lazy } from 'react'
import { createBrowserRouter } from 'react-router'

import RootLayout from '@/layouts'

export enum ROUTE_PATH {
  HOME = '/'
}

export const router = createBrowserRouter([
  {
    path: ROUTE_PATH.HOME,
    Component: RootLayout,
    children: [
      {
        index: true,
        path: ROUTE_PATH.HOME,
        Component: lazy(() => import('@/pages/home'))
      }
    ]
  }
])
